import { createAction } from "@reduxjs/toolkit";

import type { UIBlockConfig } from "./types";

export const copyUiBlock = createAction<{ uiBlock: UIBlockConfig }>(
  "COPY_UI_BLOCK",
);
